import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect } from 'react';
import { JQLSyntaxError } from '@atlassianlabs/jql-ast';
import { messages } from './messages';
import { commonMessages } from '../../../common/messages';
import { useExternalJqlErrors, useIntl, useJqlError, useScopedId, useStoreActions } from '../../../state';
import { ErrorMessage } from '@atlaskit/form';
import { JQL_EDITOR_INPUT_ID } from '../../../common/constants';
import { ErrorMessageList, ErrorMessageContainer } from './styled';
import { di } from 'react-magnetic-di';
import { useEditorViewIsInvalid } from '../../../hooks/use-editor-view-is-invalid';
import { useEditorThemeContext } from '../../../hooks/use-editor-theme'; // Max number of error messages we want to show for a given query

var MAX_EXTERNAL_ERRORS = 10;

var useFormattedErrorMessage = function useFormattedErrorMessage() {
  var _useIntl = useIntl(),
      _useIntl2 = _slicedToArray(_useIntl, 1),
      formatMessage = _useIntl2[0].formatMessage;

  var _useJqlError = useJqlError(),
      _useJqlError2 = _slicedToArray(_useJqlError, 1),
      jqlError = _useJqlError2[0];

  var _useExternalJqlErrors = useExternalJqlErrors(),
      _useExternalJqlErrors2 = _slicedToArray(_useExternalJqlErrors, 1),
      externalJqlErrors = _useExternalJqlErrors2[0];

  var _useStoreActions = useStoreActions(),
      _useStoreActions2 = _slicedToArray(_useStoreActions, 2),
      externalErrorMessageViewed = _useStoreActions2[1].externalErrorMessageViewed;

  useEffect(function () {
    // Emit a UI event whenever externalJqlErrors has changed
    externalErrorMessageViewed();
  }, [externalErrorMessageViewed, externalJqlErrors]); // Prioritise client over external errors

  if (jqlError instanceof JQLSyntaxError) {
    return "".concat(jqlError.message, " ").concat(formatMessage(messages.jqlErrorPosition, {
      lineNumber: jqlError.line,
      charPosition: jqlError.charPositionInLine + 1
    }));
  } else if (externalJqlErrors.length > 0) {
    return externalJqlErrors.length === 1 ? externalJqlErrors[0].message : /*#__PURE__*/React.createElement(ErrorMessageList, null, externalJqlErrors.slice(0, MAX_EXTERNAL_ERRORS).map(function (error, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, error.message);
    }));
  } else if (jqlError !== null) {
    return formatMessage(commonMessages.unknownError);
  }

  return null;
};

export var JQLValidationMessage = function JQLValidationMessage() {
  var _useScopedId = useScopedId(JQL_EDITOR_INPUT_ID),
      _useScopedId2 = _slicedToArray(_useScopedId, 1),
      editorId = _useScopedId2[0];

  var errorMessage = useFormattedErrorMessage();
  var editorViewIsInvalid = useEditorViewIsInvalid();

  var _useEditorThemeContex = useEditorThemeContext(),
      isSearch = _useEditorThemeContex.isSearch;

  return errorMessage !== null && editorViewIsInvalid ? /*#__PURE__*/React.createElement(ErrorMessageContainer, {
    isSearch: isSearch
  }, /*#__PURE__*/React.createElement(ErrorMessage, {
    testId: "jql-editor-validation"
  }, /*#__PURE__*/React.createElement("span", {
    role: "alert",
    "aria-describedby": editorId
  }, errorMessage))) : null;
};